var exports = {
  "banner": "x8b4e8595--d96820--banner",
  "click-overlay": "x8b4e8595--d96820--click-overlay",
  "brand-pink": "x8b4e8595--d96820--brand-pink",
  "primary-default": "x8b4e8595--d96820--primary-default",
  "primary-accent": "x8b4e8595--d96820--primary-accent",
  "brand-peach": "x8b4e8595--d96820--brand-peach",
  "gradient-linear-primary-brand-pink": "x8b4e8595--d96820--gradient-linear-primary-brand-pink",
  "gradient-linear-diagonal-primary-brand-pink": "x8b4e8595--d96820--gradient-linear-diagonal-primary-brand-pink",
  "gradient-linear-diagonal-primary-brand-peach": "x8b4e8595--d96820--gradient-linear-diagonal-primary-brand-peach",
  "content": "x8b4e8595--d96820--content",
  "description": "x8b4e8595--d96820--description",
  "labels": "x8b4e8595--d96820--labels",
  "title": "x8b4e8595--d96820--title",
  "illustration": "x8b4e8595--d96820--illustration",
  "footer": "x8b4e8595--d96820--footer",
};

module.exports = exports;
